import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UsuarioService } from '../shared/service/usuario/usuario.service';

declare var $: any;

@Component({
    selector: 'app-redefinicao-pin',
    templateUrl: './redefinicao-pin.component.html',
    styleUrls: ['./redefinicao-pin.component.css']
})
export class RedefinicaoPinComponent implements OnInit {

    private idUsuario: number;
    private idOrganizacao: number;
    @Output() enviaMensagemSucesso = new EventEmitter();
    disabledSubmit: boolean = false;

    constructor(
        private usuarioService : UsuarioService
    ) {
        const currentUser = JSON.parse(localStorage.getItem("currentUser"))
        this.idUsuario =  currentUser.id;
        this.idOrganizacao = currentUser.organizacaoId;
    }

    ngOnInit() {
    }

    enviaEmailConfirmacao() {
        this.disabledSubmit = true;
        this.usuarioService.enviarEmailRedefinicaoPIN(this.idUsuario, this.idOrganizacao).subscribe();

        this.mensagemSucesso("Enviado um e-mail para redefinição de conta");
        this.fechaJanela();
    }

    fechaJanela() {
        $('#modalRedefinirPIN').modal('toggle');
    }

    mensagemSucesso(mensagem : string){
        this.enviaMensagemSucesso.emit(mensagem);
    }
}